import dayjs from 'dayjs';
import { ITariff } from 'app/shared/model/tariff.model';

export interface ITariffPricingConstraint {
  id?: number;
  minPrice?: number | null;
  maxPrice?: number | null;
  effectiveDate?: dayjs.Dayjs | null;
  tariff?: ITariff | null;
}

export const defaultValue: Readonly<ITariffPricingConstraint> = {};
